import { subject } from '@casl/ability';
import { useAbility } from '@casl/react';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import { Button, } from '@mui/material';
import { Box } from '@mui/system';

import useEventDemographics from '@components/common/hooks/api/useEventDemographics';
import { AbilityContext, Subjects } from '@lib/permissions';

const EventDemographicsModal = ({ event }) => {

  const ability = useAbility(AbilityContext);

  const { handleDemographicsModal } = useEventDemographics(event);

  const canEdit = ability.can('edit', subject(Subjects.EVENT, event));

  return (
    <Box mt="28px">
      <Button
        id="edit-demographics-button"
        variant="contained"
        startIcon={<PersonAddIcon/>}
        onClick={handleDemographicsModal}
        disabled={!canEdit}
      >
        Edit Youth Demographics
      </Button>
    </Box>
  );
}
export default EventDemographicsModal;
